const doc = [({"da":({"js":({"reimbursements":({"travel":({"index":({"travel":"Kørsel", "my_reimbursements":"Mine refusioner", "created_for_others":"Oprettet for andre"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;